
export const performanceMixin = {
  data() {
    return {
      callNum: {}
    }
  },
  methods: {
    addCallNum(methodName) {
      if (!this.callNum[methodName]) {
        this.callNum[methodName] = 1;
      } else {
        this.callNum[methodName]++;
      }
    }
  }
};
